/**
* Checks to make sure window.localStorage is available.  localStorage throws an exception (it does not show up as null or undefined)
*  when (third party) cookies are disabled.  Perform this check whenever localStorage needs to be accessed.
*/
export function localStorageAvailable() {
    try {
        window.localStorage.setItem('test', 0);
        window.localStorage.removeItem('test');
        return true;
    } catch {
        return false;
    }
}